"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from "lucide-react";
import { cva } from "class-variance-authority";
import { cn } from "../utils/cn";
const spinner = cva("animate-spin text-current", {
    variants: {
        size: { sm: "h-3.5 w-3.5", md: "h-4 w-4", lg: "h-6 w-6", xl: "h-8 w-8" },
    },
    defaultVariants: { size: "md" },
});
export function Spinner({ size, className, label = "Loading" }) {
    return (_jsxs(_Fragment, { children: [_jsx(Loader2, { "aria-hidden": true, className: cn(spinner({ size }), className) }), _jsx("span", { className: "sr-only", children: label })] }));
}
const dot = cva("inline-block shrink-0 rounded-full", {
    variants: {
        tone: {
            success: "bg-success",
            warning: "bg-warning",
            danger: "bg-danger",
            info: "bg-info",
            neutral: "bg-neutral",
        },
        size: { sm: "h-1.5 w-1.5", md: "h-2 w-2", lg: "h-2.5 w-2.5" },
    },
    defaultVariants: { tone: "neutral", size: "md" },
});
/** Never signals with colour alone — the label is always rendered or announced. */
export function StatusDot({ tone, size, label, pulse = false, className, }) {
    return (_jsxs("span", { className: cn("inline-flex items-center gap-2", className), children: [_jsxs("span", { className: "relative inline-flex", children: [_jsx("span", { "aria-hidden": true, className: dot({ tone, size }) }), pulse ? (_jsx("span", { "aria-hidden": true, className: cn(dot({ tone, size }), "absolute inset-0 animate-ping opacity-60") })) : null] }), _jsx("span", { className: "text-body-sm text-content-secondary", children: label })] }));
}
//# sourceMappingURL=status.js.map